export default {
  name: 'Search',
  props: ['value', 'placeholder'],
  methods: {
    onInput() {
      this.$emit('input', this.$refs.searchInput.value)
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/search/search.js